import React from "react";
import IpSettingsListing from "./IpSettingsListing";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import { Card, Col, Container, Row } from "reactstrap";

const IpSettings = () => {
  const breadcrumbItems = [
    { title: "Settings", link: "" },
    { title: "IP Whitelisting", link: "/setting/ipwhitelisitng" }
  ];

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb items={breadcrumbItems} />
          <Card>
            <IpSettingsListing />
          </Card>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default IpSettings;
